<template>
  <div>
    <section>
      <div class="header">
        <h5>{{categoryDetail.Title}}</h5>
        <div class="clearfix">
          <span class="fl">时间：{{categoryDetail.CreateTime}}</span>
        </div>
      </div>
      <article id="article-content">
        <div v-html="categoryDetail.DetailDesc"></div>
      </article>
    </section>
    <footer>
      <ul class="footer-menu">
        <li>
          <router-link :to="{path:'/'}">
            <i class="home"></i>
            <span>首页</span>
          </router-link>
        </li> 
        <li @click="onShow()">
          <i class="Share"></i>
          <span>分享</span>
        </li>
      </ul>
    </footer>
    <share v-show='shareShow.isShow' :shareShow='shareShow' :info="returnInfo"></share>
    <footer-logo></footer-logo>
  </div>
</template>

<script>
  import footerLogo from '@/components/footerLogo.vue';
  import share from '@/components/share.vue';
  export default {
    components: {
      share,
      'footer-logo': footerLogo
    },
    data() {
      return {
        shareShow: {
          isShow: false
        },
        isShow: false,
        categoryDetail: {},
        categoryNo: this.$route.params.categoryNo,        
        returnInfo: {
          title: '',
          desc: '',
          link: location.href,
          image: ''
        }
      }
    },
    created() {
      this.getcategoryDetail();
    },
    methods: {
      onShow() {
        this.shareShow.isShow = true;
      },
      getcategoryDetail() {
        this.$fetch("/api/CmsCategory/GetCategoryInfo?cateNo="+this.categoryNo).then(result => {
          this.categoryDetail = result;
          this.returnInfo.title = result.Title;
          this.returnInfo.desc = result.ShortDesc;
          this.returnInfo.image = result.TitleImagePath;
        });
      }
    }
  };

</script>

<style lang="less" scoped>
  

  .header {
    padding: 30/@rem-size 24/@rem-size 20/@rem-size;
    border-bottom: 1px solid #e5e5e5;
    background: #fff;

    h5 {
      font-size: 32/@rem-size;
      font-weight: normal;
      color: #333;
      line-height: 48/@rem-size;
    }

    span {
      color: #999;
      font-size: 28/@rem-size;
      display: block;
      margin-top: 20/@rem-size;
    }
  }

  article {
    background: #fff;
    padding: 24/@rem-size;
    font-size: 28/@rem-size;
    line-height: 40/@rem-size;
  }

  footer {
    width: 100%;
    height: 98/@rem-size;
    background: #fff;
    box-shadow: 0 0 18/@rem-size 0 rgba(208, 208, 208, 0.2);
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 8/@rem-size 46/@rem-size 0;
    z-index: 888;

    ul {
      display: flex;
      justify-content: space-between;

      li {
        &:active {
          opacity: 0.8;
        }

        span {
          display: block;
          color: #999;
          font-size: 24/@rem-size;
          margin-top: 8/@rem-size;
        }
      }
    }
  }

</style>
